import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ProtectedUsers } from "../../shared/ProtectedUsers/ProtectedUsers";
import { PROJECT_ADMIN } from "../../../constants/constants";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { rootState } from "../../../redux/store";
import { projectFeatureListPending } from "./ProjectFeatureList.slice";
import { saveProjectFeatureList } from "./projectFeatureListFastUpdate.slice";
import { Subwindow } from "../../layout/Subwindow/Subwindow";
import { ProjectFeatureListMain } from "./ProjectAdminConfigMain/ProjectFeatureListMain";
import { Loader } from "../../shared/Loader/Loader";
import { RelativeCenter } from "../../layout/RelativeCenter/RelativeCenter";
import { projectFeatureListPostPending } from "./ProjectFeatureListPost.slice";
import { use } from "i18next";

export const ProjectAdminConfig = () => {
    const dispatch = useAppDispatch();
    const {projectId} = useParams();

    const {userAndTokenData} = useAppSelector((state:rootState)=>state.loginUserAndTokenData)
    const {projectFeatureList} = useAppSelector((state:rootState)=>state.projectFeatureListFastUpdate)

    const {projectFeatureListData, projectFeatureListError, projectFeatureListLoading} = useAppSelector((state:rootState)=>state.projectFeatureList)
    const {projectFeaturePostListData, projectFeaturePostListError, projectFeaturePostListLoading} = useAppSelector((state:rootState)=>state.projectFeatureListPost)


    useEffect(()=>{
        console.log(projectFeatureList)
    }, [projectFeatureList])

    useEffect(()=>{
        if(projectId){
            dispatch(projectFeatureListPending({url: `project/${projectId}/features`, token: userAndTokenData?.token || ''}))
        }
    }, [dispatch, projectId, userAndTokenData?.token])

    useEffect(()=>{
        if(projectFeatureListData.length > 0){
            dispatch(saveProjectFeatureList(projectFeatureListData))
        }
    },[dispatch, projectFeatureListData])

    useEffect(()=>{
        if(projectFeatureList.length > 0){
            dispatch(projectFeatureListPostPending({
                url: `project/${projectId}/features`, 
                token: userAndTokenData?.token || '',
                body: projectFeatureList
            }))
        }
        console.log('CHANGE')
    }, [projectFeatureList])
    




    return (
        <ProtectedUsers protectedUsers={PROJECT_ADMIN} showWarningMessage>
            <section className="staging-section">
                <Subwindow
                    headerSettings={false}
                    isSingle={true}
                    title={'Dashboard list'}
                    footer={<></>}
                    mainColor="grey-superLight"
                    main={
                        projectFeatureListLoading
                        ?
                        <RelativeCenter>
                            <Loader label="Loading feature list" color="accent-green" height={24} width={24}/>
                        </RelativeCenter>
                        :
                        <ProjectFeatureListMain projectFeatureList={projectFeatureList}/>
                    }
                />
            </section>
        </ProtectedUsers>
    )
}